const mlsComplianceData = {
  displayField: 'name',
  name: 'mlsComplianceData',
  description: 'Contentful new schema template',
  fields: [
    {
      id: 'name',
      name: 'MLS Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'resoId',
      name: 'RESO ID',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'disclaimer',
      name: 'Disclaimer',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Logo',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'defaultCurrency',
      name: 'Default Currency',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'USD', 'CAD', 'MXN', 'EUR', 'BSD' ] } ],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'mlsComplianceData',
    version: 8,
    updatedAt: '2023-08-04T14:21:16.081Z'
  }
};
export default mlsComplianceData;